import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import sentry from 'legacy/utils/sentry'

import type { SubmitBulkSpotQuoteParams } from '../infra/BulkSpotQuoteMapper'
import { SpotQuoteRepository } from '../infra/SpotQuoteRepository'

export type SubmitBulkSpotQuoteFactoryDependencies = {
  spotQuoteRepository: SpotQuoteRepository
}

export function submitBulkSpotQuoteFactory({
  spotQuoteRepository,
}: SubmitBulkSpotQuoteFactoryDependencies) {
  return async function submit(
    params: SubmitBulkSpotQuoteParams,
    config?: { signal?: AbortSignal }
  ) {
    try {
      return await spotQuoteRepository.submitBulkSpotQuote(params, config)
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not submit the bulk spot quote', { cause: error as Error })
    }
  }
}

export function submitBulkSpotQuote(
  params: SubmitBulkSpotQuoteParams,
  config?: { signal?: AbortSignal }
) {
  const httpClient = new ShipperGuideClient()
  const spotQuoteRepository = new SpotQuoteRepository({ httpClient })
  const submit = submitBulkSpotQuoteFactory({ spotQuoteRepository })

  return submit(params, config)
}
